export default {
  平台: 'Platform',
  导出: 'export',
  序列: 'Order',
  操作人员: 'Operator',
  登录号: 'Login Account',
  登录地址: 'Login Address',
  所在单位: 'Work Unit',
  登录时间: 'Login Time',
  机构关联用户: 'Org rel User',
  ip地址: 'IP Address',
  登录方式: 'Login Method',
  累计登录次数: 'Cumulative Logins',
  角色别名: 'Role Alias',
  角色名称: 'Role Name',
  控件信息:'Ctl Acl',
  角色类型: 'Role Type',
  操作时间: 'Operation Time',
  加载中: 'Loading...',
  基本信息: 'Basic Information',
  空间LOGO: 'Space LOGO',
  请输入空间logo: 'Please enter the space logo',
  上传logo: 'Upload Logo',
  常规logo的宽度: 'Width of regular logo',
  常规logo的高度: 'Height of regular logo',
  空间名称: 'Space Name',
  系统名称: 'System Name',
  空间简称: 'Space abbreviation',
  空间编码: 'Spatial Coding',
  描述: 'Describe',
  序号: 'Order',
  请上传png格式或jpg格式: 'Please upload png format or jpg format',
  上传失败: 'Upload Failed',
  空间管理信息: 'Space Management Information',
  登录名: 'Login Name',
  网址: 'Website',
  空间说明信息: 'Space Description Information',
  空间类型: 'Space Type',
  负责人: 'Leader',
  默认pc空间: 'Default PC Space',
  邮编: 'Zip code',
  电话: 'Telephone',
  传真: 'Fax',
  取消: 'Cancel',
  确定: 'OK',
  修改: 'Modify',
  人员: 'Personnel',
  部门: 'Department',
  岗位: 'Post',
  角色: 'Role',
  职务级别: 'Job Level',
  编外人员: 'Non-staff Personnel',
  群组: 'Group',
  子账号: 'Sub-account',
  修改成功: 'Modified successfully',
  授权信息: 'Authorization Info',
  新增: 'Add',
  新增人员: 'Add Personnel',
  添加部门: 'Add Department',
  添加: 'Add',
  请输入: 'Please enter',
  请选择: 'Please select',
  操作成功: 'Operation succeeded',
  编辑成功: 'Edit succeeded',
  新增职务级别成功: 'Successfully added job level',
  批量删除: 'Batch Delete',
  请选择需要删除的记录: 'Please select the record to delete',
  您确定删除选择的记录吗: 'Are you sure to delete the selected record',
  '职级导出.xlsx': 'Rank Export.xlsx',
  删除: 'Delete',
  关联用户: 'Associated Users',
  角色关联用户: 'Role associated user',
  编辑: 'Edit',
  编辑职务级别成功: 'Edit job level succeeded',
  职务级别名称: 'Job Level Name',
  职务级别代码: 'Job Level Code',
  职务级别序号: 'Job level Order',
  重复序号处理: 'Duplicate Order processing',
  插入: 'Insert',
  重复: 'Repeat',
  启用状态: 'Enable Status',
  数据来源: 'DataSource',
  状态: 'Status',
  操作: 'Action',
  岗位编码: 'Post code',
  岗位名称: 'Position Name',
  岗位类别: 'Position Category',
  排序号: 'Order No',
  请填写职务级别名称: 'Please fill in the title level name',
  请填写职务级别代码: 'Please fill in the job level code',
  请填写职务级别序号: 'Please fill in the job level serial number',
  用户名称: 'UserName',
  用户账号: 'User Account',
  所在机构: 'Organization',
  组织架构: 'Organizational Structure',
  选择人员: 'Select personnel',
  新增机构成功: 'New organization succeeded',
  机构人员: 'Institutional Staff',
  编辑机构成功: 'Editing organization succeeded',
  上级机构: 'Superior Organization',
  机构名称: 'Organization Name',
  机构编码: 'Institution Code',
  机构主管: 'Agency director',
  分管领导: 'Leader',
  机构管理员: 'Institution Administrator',
  机构职能: 'Institutional Functions',
  机构级次: 'Organization Level',
  请选择上级机构: 'Please select a superior organization',
  请输入机构名称: 'Please enter the organization name',
  启用: 'Enable',
  停用: 'Deactivate',
  编辑角色成功: 'Edit role successfully',
  控件编码: 'Control Encoding',
  控件名称: 'Control Name',
  请填写岗位编码: 'Please fill in the post code',
  请填写岗位名称: 'Please fill in the position name',
  请填写岗位类别: 'Please fill in the position category',
  新增角色成功: 'Role added successfully',
  新增成功: 'Added Successfully',
  确认密码不一致: 'The confirmation password is inconsistent',
  请输入确认密码: 'Please enter the confirmation password',
  保存: 'Save',
  授权成功: 'Authorization succeeded',
  修改密码: 'Change Password',
  切换用户: 'Switch User',
  请输入密码: 'Please input a password',
  子账号手机号: 'Sub-account mobile number',
  昵称: 'Nickname',
  密码: 'Password',
  确认密码: 'Confirm Password',
  用户角色: 'User Role',
  结算人员: 'Settlement Personnel',
  日常业务人员: 'Daily business personnel',
  业务处理人员: 'Business processing personnel',
  浏览人员: 'Browsers',
  创建时间: 'Creation Time',
  请填写子账号: 'Please fill in the sub-account',
  请选择用户角色: 'Please select user role',
  请输入昵称: 'Please enter a nickname',
  资源信息: 'Resource Information',
  输入资源名称: 'Enter resource name',
  保存成功: 'Saved successfully',
  角色信息: 'Role Information',
  输入角色名称: 'Enter role name',
  控件信息: 'Control Information',
  输入控件名称: 'Enter control name',
  输入机构名称: 'Enter organization name',
  机构信息: 'Organization Information',
  上级资源: 'Superior Resources',
  上级资源名称: 'Superior Resources Name',
  资源类型: 'Resource Type',
  菜单资源: 'Menu Resources',
  界面资源: 'Interface Resources',
  打开方式: 'Open with',
  主界面: 'Main Interface',
  资源名称: 'Resource Name',
  资源所属: 'Resource Ownership',
  客户界面: 'Customer Interface',
  资源路径: 'Resource Path',
  图标: 'Icon',
  备注: 'Remarks',
  url地址: 'Url Address',
  字体图标: 'Font Icon',
  请输入资源名称: 'Please enter the resource name',
  请填写资源路径: 'Please fill in the resource path',
  系统资源: 'System Resource',
  菜单: 'Menu',
  界面: 'Interface',
  默认角色: 'Default Role',
  角色编码: 'Role Code',
  请填写角色编码: 'Please fill in the role code',
  请填写角色名: 'Please fill in the role name',
  确定将选择数据删除: 'Confirm to delete the selected data',
  删除角色管理成功: 'Successfully deleted role management',
  查看用户: 'View Users',
  详情: 'Detail',
  平台下发: 'Platform Distribution',
  租户角色: 'Unit Role',
  是: 'Yes',
  否: 'No',
  权限设置: 'Permission Setting',
  角色权限配置: 'Role Permission Configuration',
  接口权限: 'Interface Permissions',
  菜单权限: 'Menu Permissions',
  请选择至少一项角色权限: 'Please select at least one role permission',
  操作失败: 'Operation failed',
  当前仅支持选择一条数据: 'Currently, only one piece of data is supported',
  角色权限配置成功: 'Role permission configuration succeeded',
  上传头像成功: 'Successfully uploaded the avatar',
  请填写确认密码: 'Please fill in the confirmation password',
  确认密码与密码不一致: 'The confirmation password is inconsistent with the password',
  上传: 'Upload',
  姓名: 'Name',
  个人角色: 'Personal Role',
  所属机构: 'Affiliated Organization',
  语言: 'Language',
  英文: 'English',
  正式: 'Formal',
  人员状态: 'Personnel Status',
  入职: 'Entry',
  离职: 'Quit',
  男: 'Male',
  女: 'Female',
  手机号: 'Phone Number',
  邮箱: 'Email',
  头像: 'Avatar',
  人员角色: 'Personnel Role',
  默认语言: 'Default Language',
  请填写姓名: 'Please fill in your name',
  请填写登录名: 'Please fill in the login name',
  请填写密码: 'Please fill in the password',
  请选择角色: 'Please select a role',
  请选择组织: 'Please select an organization',
  请填写排序号: 'Please fill in the order No',
  请填写个人角色: 'Please fill in personal role',
  请填写所属机构: 'Please fill in the organization',
  租户: 'Tenant',
  创建人: 'Creator',
  系统环境: 'System Environment',
  请求URI: 'Request URI',
  '是一个基于Vue3.0、Vite、 Ant-Design-Vue 、TypeScript 的后台解决方案，目标是为中大型项目开发,提供现成的开箱解决方案及丰富的示例,原则上不会限制任何代码用于商用。':
    'Is a background solution based on Vue3.0, Vite, Ant-Design-Vue and TypeScript. The goal is to provide ready-made out-of-the-box solutions and rich examples for medium and large projects. In principle, it will not limit any code to be used commercially.',
  最后编译时间: 'Final compilation time',
  文档地址: 'Document Address',
  预览地址: 'Preview Address',
  生产环境依赖: 'Production Environment Dependence',
  开发环境依赖: 'Development Environment Dependence',
  项目信息: 'Project Information',
  关于: 'About',
  版本: 'Version',
  每行显示数量: 'Display quantity per line',
  刷新: 'Refresh',
  是否确认删除: 'Confirm Delete',
  类型: 'Type',
  总: 'Total',
  条: 'data',
  上方插入行: 'Insert a row above',
  下方插入行: 'Insert a row below',
  复制: 'Copy',
  系统图标: 'System Icon',
  输入名称关键字查询: 'Enter name keyword query',
  输入用户名称或者拼音进行查询: 'Enter user name or Pinyin to query',
  选择用户: 'Select User',
  总数: 'Total',
  搜索: 'Search',
  重置: 'Reset',
  '插槽 拖拽组件到此处': 'Slot drag the component here',
  内容标签切换: 'Content label toggle',
  边框类型: 'Border Type',
  有标题边框: 'With title border',
  带边框: 'With border',
  无标题边框: 'No title border',
  无边框: 'no border',
  更多: 'More',
  查询标签切换: 'Query label switch',
  标签名称: 'Label Name',
  边框标题: 'Border Title',
  宽度: 'width',
  '宽度可以是auto、100%，或者使用span：24宫格，或者是大于100的数字':
    'The width can be auto, 100%, or span: 24, or a number greater than 100',
  '高度可以是auto、100%，或者是大于180的数字':
    'The height can be auto, 100%, or a number greater than 180',
  圆角度: 'Circle Angle',
  无: 'None',
  小: 'Small',
  中: 'Medium',
  大: 'Large',
  性别: 'Gender',
  人员类型: 'Personnel Type',
  开启背景色: 'Turn on background color',
  背景色: 'Background color',
  上下间距: 'Top and bottom spacing',
  左右间距: 'Left and right spacing',
  标题: 'Title',
  标题显示: 'Title Display',
  标题内容: 'Title Content',
  左: 'Left',
  Center: 'Center',
  右: 'Right',
  标题位置: 'Title Position',
  标签: 'Label',
  显示: 'Display',
  上: 'Top',
  Middle: 'Middle',
  下: 'Bottom',
  面积颜色: 'Area Color',
  开启渐变: 'Turn on gradient',
  图表标题: 'Chart Title',
  图形属性: 'Graph Properties',
  柱体颜色: 'Column Color',
  粗细: 'Thickness',
  位置: 'Position',
  横行显示: 'Horizontal Display',
  竖向显示: 'Vertical Display',
  左倾斜显示: 'Left Tilt Display',
  右倾斜显示: 'Right Tilt Display',
  标签文字: 'Label Text',
  图列: 'Chart Columns',
  图列名称: 'Chart Columns Name',
  列: 'Column',
  访问数: 'Number of visits',
  总访问数: 'Total Visits',
  月: 'Month',
  显示标题: 'Display title',
  类型名称: 'Type Name',
  数据格式: 'Data Format',
  数字: 'Number',
  美元: 'Dollar',
  人民币: 'RMB',
  小数位: 'Decimal Places',
  百分位: 'Centile',
  千分位: 'Thousandth',
  显示图标: 'Display Icon',
  图标大小: 'Icon Size',
  显示子标题: 'Dispaly Sub-Title',
  显示子数量: 'Show Sub-Quantity',
  颜色: 'Color',
  全部应用: 'All App',
  最近使用: 'Recently Used',
  我收藏的: 'My Collection',
  系统应用: 'System Application',
  应用宫格: 'Apply Gongge',
  面积图: 'Area Chart',
  柱状图: 'Histogram',
  表格: 'Table',
  动态数字: 'Dynamic Number',
  链接: 'Link',
  折线图: 'Line Chart',
  列表: 'Tabulation',
  标题属性: 'Title Properties',
  数字属性: 'Numeric Properties',
  默认值: 'Default Value',
  前缀: 'Prefix',
  后缀: 'Suffix',
  字体大小: 'Font Size',
  字体颜色: 'Font Color',
  饼图: 'Pie Chart',
  流程统计: 'Process Statistics',
  任务中心: 'Task Center',
  我的待办: 'My To-do',
  我的申请: 'My Application',
  我的抄送: 'My Cc',
  我的处理: 'My handling',
  待办列表: 'To-do list',
  '研发部：魏勇【架构师】': 'R&D Department: Wei Yong [architect]',
  '审批节点【李总】': 'Approval node [President Li]',
  查看详情: 'View Details',
  流程待办: 'Process To-do',
  摆放位置: 'Place',
  左侧: 'Left Side',
  交替展现: 'Alternating Display',
  右侧: 'Right Side',
  时间轴信息说明: 'Timeline Information Description',
  时间轴: 'Time Axis',
  内容: 'Content',
  '自由布局模式下，请保留至少1个栏目！': 'Please reserve at least 1 column in free layout mode!',
  记录内容: 'Record Content',
  简单列表: 'Simple List',
  平台运营: 'Platform Operation',
  平台公告: 'Platform Announcement',
  公告类型: 'Announcement Type',
  公告内容: 'Announcement Content',
  公告日期: 'Announcement Date',
  描述信息: 'Descriptive Information',
  标题信息: 'Title Information',
  用户头像: 'User Avatar',
  用户图标带内容: 'User icon with content',
  您确定删除该记录: 'Are you sure to delete this record',
  信息标题: 'Message Title',
  图片: 'Picture',
  用户说明信息编辑: 'Edit user description information',
  请拖拽组件到此处: 'Please drag components here',
  组织成员: 'Organization Members',
  成员: 'Member',
  角色成员: 'Role Members',
  已选择: 'Selected',
  全部: 'All',
  管理类: 'Management',
  其他: 'Other',
  您确定重置选择的密码吗: 'Are you sure to reset the selected password?',
  重置密码: 'Reset Password',
  组织模型模块: 'Organization Model Module',
  资源权限中心: 'Resource Permission Center',
  系统日志: 'System Log',
  应用现代化平台: 'Digital innovation  Platform',
  查看应用说明: 'View Application Description',
  分享应用: 'Sharing Application',
  '地址复制成功！': 'Address copied successfully!',
  账套管理: 'A/C set Mg',
  子账号管理: 'Sub-account Mg',
  部门管理: 'Department Mg',
  岗位管理: 'Post Mg',
  角色管理: 'Role Mg',
  人员管理: 'Personnel Mg',
  职务级别管理: 'Job Level Mg',
  系统资源管理: 'System Resource Mg',
  系统资源权限管理: 'System Resource Permission  Mg',
  登录日志: 'Login Log',
  错误日志: 'Error Log',
  流程: 'Process',
  用户信息: 'User Info',
  错误提示: 'Error Prompt',
  信息提示: 'Information Prompt',
};
